<template>
    <v-container fluid>
        <v-row v-if="showPdfPreview">
            <div
                style="
                    display: show;
                    z-index: 9999999;
                    position: fixed;
                    top: 0px;
                    left: 0px;
                    background-color: rgba(255, 255, 255, 0.074);
                    width: 100%;
                    height: 100vw;
                "
            >
                <div style="margin-top: 20px; margin-bottom: 40px; width: 40%; height: 100vh; margin: 0 auto">
                    <v-btn
                        style="float: right; margin-top: 50px; margin-bottom: 10px"
                        depressed
                        @click="closePDFpreview()"
                        icon
                    >
                        <v-icon large>fas fa-window-close</v-icon>
                    </v-btn>
                    <iframe
                        id="pdf-preview-div"
                        style="width: 100%; margin-bottom: 20px; height: 87vh; display: block"
                        :src="pdfLink"
                    >
                        <p>Your browser does not support iframes.</p>
                    </iframe>
                </div>
            </div>
        </v-row>
        <v-row>
            <ImageViewer
                :images="imageList"
                :toggler="lightboxShow"
                :index="lighboxIndex"
                @closeViewer="lightboxShow = false"
            >
            </ImageViewer>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-title>
                        {{ category.label }}
                        <v-tooltip bottom>
                            <template v-slot:activator="{on, attrs}">
                                <v-btn icon v-bind="attrs" v-on="on" @click="seeMore = !seeMore">
                                    <v-icon small>fas fa-caret-down</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('tooltips.seeMore') }}</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-card-text>
                        <v-row v-if="seeMore == true">
                            <v-col>
                                <v-data-table
                                    :headers="objectHeaders"
                                    :items="objectList"
                                    dense
                                    class="row-item"
                                    :items-per-page="-1"
                                    :hide-default-footer="true"
                                    :no-data-text="$t('labels.noData')"
                                >
                                    <template v-slot:item="row">
                                        <tr
                                            :class="{'cursor-pointer': true}"
                                            :style="row.item.expired == true ? 'color: red' : ''"
                                        >
                                            <td class="font-weight-bold">
                                                <span @click="$emit('edit', row.item.id)">
                                                    {{ row.item.document_type_display }} &nbsp;
                                                </span>

                                                <v-btn
                                                    depressed
                                                    @click="fileClicked(row.item)"
                                                    icon
                                                    v-if="row.item.uploaded_file.link != ''"
                                                >
                                                    <v-icon small>fas fa-eye</v-icon>
                                                </v-btn>
                                            </td>
                                            <td>
                                                {{ row.item.issuing_country_display }}
                                            </td>
                                            <td>
                                                {{ row.item.issued_by }}
                                            </td>
                                            <td>
                                                {{ row.item.document_number }}
                                            </td>
                                            <td>
                                                {{ row.item.date_issued_display }}
                                            </td>
                                            <td class="font-weight-bold">
                                                {{
                                                    row.item.document_expiration_type_id == 4
                                                        ? 'Unlimited'
                                                        : row.item.date_of_expiry_display
                                                }}
                                            </td>
                                            <td>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <v-btn icon v-bind="attrs" @click="remove(row.item)" v-on="on">
                                                            <v-icon small>fas fa-archive</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ $t('tooltips.archive') }}</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ImageViewer from './trinkets/ImageViewer';
export default {
    name: 'SeafarerDocumentsTable',
    components: {
        ImageViewer,
    },
    watch: {
        reload: {
            handler: function () {
                if (this.reload == 'documents') {
                    this.reloadData();
                }
            },
            deep: true,
        },
    },
    props: ['seafarer', 'category', 'reload'],
    data: function () {
        return {
            showPdfPreview: false,
            imageList: [],
            pdfFormats: ['pdf', 'PDF'],
            imageFormats: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            lightboxShow: false,
            lighboxIndex: 0,
            objectList: [],
            objectHeaders: [
                {text: this.$t('fields.documentType'), sortable: false},
                {text: this.$t('fields.issuingCountry'), sortable: false},
                {text: this.$t('fields.issuedBy'), sortable: false},
                {text: this.$t('fields.documentNumber'), sortable: false},
                {text: this.$t('fields.dateIssued'), sortable: false},
                {text: this.$t('fields.dateOfExpiry'), sortable: false},
                {text: '', value: 'actions', type: '', sortable: false, allowFilter: false},
            ],
            seeMore: true,
            pdfLink: '',
        };
    },

    methods: {
        closePDFpreview() {
            this.showPdfPreview = false;
            this.pdfLink = '';
        },
        fileClicked(item) {
            let link = item.uploaded_file.link;
            if (
                this.imageFormats.includes(
                    item.uploaded_file.original_name.slice(
                        ((item.uploaded_file.original_name.lastIndexOf('.') - 1) >>> 0) + 2,
                    ),
                )
            ) {
                const index = this.imageList.indexOf(link);
                if (index !== null && index != -1) {
                    this.lighboxIndex = index;
                }
                this.lightboxShow = true;
            } else if (
                this.pdfFormats.includes(
                    item.uploaded_file.original_name.slice(
                        ((item.uploaded_file.original_name.lastIndexOf('.') - 1) >>> 0) + 2,
                    ),
                )
            ) {
                this.showPdfPreview = true;
                this.pdfLink = item.uploaded_file.public_link;
            } else {
                window.open(link);
            }
        },
        remove(item) {
            let vm = this;
            let objectId = item.id;
            this.$verify(this.$t('alerts.archiveQuestion'), (result) => {
                if (result) {
                    vm.$APICall('put', 'archive-seafarer-documents/' + objectId, {}, (data, succes) => {
                        if (succes) {
                            this.reloadData();
                        } else {
                            vm.$alert(vm.$t('alerts.basicError'));
                        }
                    });
                }
            });
        },

        reloadData() {
            let vm = this;
            let category = this.category.value;
            this.$APICall(
                'get',
                'seafarer-documents/' + this.seafarer.id,
                {category},
                (data, success) => {
                    if (success) {
                        vm.objectList = data.items;
                        vm.objectList.forEach((element) => {
                            if (element != null) {
                                if (
                                    vm.imageFormats.includes(
                                        element.uploaded_file.original_name.slice(
                                            ((element.uploaded_file.original_name.lastIndexOf('.') - 1) >>> 0) + 2,
                                        ),
                                    )
                                ) {
                                    vm.imageList.push(element.uploaded_file.link);
                                }
                            }
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
    },
    mounted() {
        this.reloadData();

        this.$modalBus.$on('reloadDocumentsTable', () => {
            this.reloadData();
        });
    },
};
</script>
<style scoped>
.v-data-table::v-deep th {
    font-size: 14px !important;
    font-weight: 800;
}
.v-data-table::v-deep .v-data-table__wrapper {
    min-height: 96px; /* dense zaglavlje 32px + 2 dense retka po 32px */
}
</style>
